// @ts-strict-ignore
import styled, { css } from "styled-components";

/* eslint-disable prettier/prettier */

const getBorderRadius = (isSmall, buttonTheme, mobile = false) => {
  if (buttonTheme && buttonTheme.borderRadius) return buttonTheme.borderRadius;
  if (isSmall) return "999px";
  return mobile ? "999px" : "999px";
};

export const StyledButton = styled.button.attrs(props => ({
  type: props.type || "button"
}))`
  display: ${({ hideOnMobile }) => (hideOnMobile ? "none" : "block")};
  visibility: ${({ isOverlayOpen }) => (isOverlayOpen ? "hidden" : "visible")};
  outline: 0;
  padding: ${({ isSmall }) => (isSmall ? "0" : "0 24px")};
  margin: 0;
  cursor: pointer;
  min-width: ${({ isSmall }) => (isSmall ? "100px" : "160px")};
  height: ${({ isSmall }) => (isSmall ? "40px" : "48px")};
  border-radius: ${({ isSmall, buttonTheme }) => getBorderRadius(isSmall, buttonTheme, true)};
  background-color: ${({ buttonTheme }) => buttonTheme.backgroundColor};
  color: ${({ buttonTheme }) => buttonTheme.textColor};
  font-size: ${({ isSmall }) => (isSmall ? 12 : 16)}px;
  font-weight: ${({ theme, isBold }) => (isBold ? theme.fontWeight.bold : theme.fontWeight.semiBold)};
  line-height: 16px;
  letter-spacing: 0.33px;
  text-align: center;
  border: solid 2px;
  border-color: ${({ buttonTheme }) => buttonTheme.borderColor};
  transition: border-color 300ms ease-in, color 300ms ease-in, background-color 300ms ease-in;
  white-space: nowrap;

  &:hover {
    border-color: ${({ buttonTheme }) => buttonTheme.hoverBorderColor};
    background-color: ${({ buttonTheme }) => buttonTheme.hoverBackgroundColor};
    color: ${({ buttonTheme }) => buttonTheme.hoverTextColor};
  }

  &:active {
    border-color: ${({ buttonTheme }) => buttonTheme.clickBorderColor};
    background-color: ${({ buttonTheme }) => buttonTheme.clickBackgroundColor};
    color: ${({ buttonTheme }) => buttonTheme.clickTextColor};
  }

  ${({ theme: { media } }) => media.desktop`
    min-width: ${({ isSmall }) => (isSmall ? "120px" : "180px")};
    height: ${({ isSmall }) => (isSmall ? "40px" : "56px")};
    padding: ${({ isSmall }) => (isSmall ? "0 16px" : "0 32px")};
    font-size: ${({ isSmall }) => (isSmall ? 14 : 18)}px;
    border-radius: ${({ isSmall, buttonTheme }) => getBorderRadius(isSmall, buttonTheme)};
  `};
  ${({ theme: { media } }) => media.tablet`
    display: block;
  `};

  ${({ hiddenBefore }) =>
    !hiddenBefore
      ? ""
      : css`
          @media (max-width: ${hiddenBefore}px) {
            display: none !important;
          }
        `};
`;
